// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"115":"students","130":"teaching","133":"layout","242":"schools","255":"test","473":"analysis","962":"home","966":"login"}[chunkId] + "." + {"115":"59ad3879","130":"a66334a5","133":"c31a48e3","242":"77733f5c","255":"da641248","473":"8f8450a6","962":"9be19d8e","966":"5e3d2fcd"}[chunkId] + ".js";
};